import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs'; 
import { ApiError } from 'src/app/core/errors/api-error.model';

@Injectable({ providedIn: 'root' })
export class ErrorService {
  private readonly _state = new BehaviorSubject<ApiError | null>(null);
  readonly state$ = this._state.asObservable();
 
  get snapshot(): ApiError | null { return this._state.value; }
 
  show(err: ApiError): void {
    this._state.next(err);
  }
  
  clear(): void {
    this._state.next(null);
  }
}